import { type JobContext } from '../background-job';
import { remoteCartServiceV2 } from '../../services';

export async function fetchCartsJobHandlerV2(context?: JobContext) {
    if (!navigator.onLine) {
        throw new Error('offline');
    }

    const lastSyncTime = context?.lastExecutedAt
        ? new Date(context.lastExecutedAt).toISOString()
        : undefined;

    await remoteCartServiceV2.fetchAndBulkUpsert(lastSyncTime);
}
